const TWO_COLUMN_SELECTOR = "[data-two-column]";
const TWO_COLUMN_REVEAL_SELECTOR = ".two-column--equal.two-column--gap-noGap";
const TWO_COLUMN_REVEAL_PENDING_CLASS = "two-column--reveal-pending";
const TWO_COLUMN_REVEAL_VISIBLE_CLASS = "two-column--reveal-visible";
const DESKTOP_QUERY = window.matchMedia("(min-width: 64rem)");

function updateStickyColumn(section) {
	const columns = [...section.querySelectorAll("[data-two-column-side]")];

	for (const column of columns) {
		column.classList.remove("is-sticky");
	}

	if (!DESKTOP_QUERY.matches || columns.length !== 2) {
		return;
	}

	const [left, right] = columns;
	const stickyColumns = columns.filter(
		(column) => (column.dataset.twoColumnSticky || "sticky") === "sticky",
	);

	if (stickyColumns.length === 0) {
		return;
	}

	const candidate = stickyColumns.length === 1
		? stickyColumns[0]
		: stickyColumns.reduce((shorter, column) =>
			column.offsetHeight < shorter.offsetHeight ? column : shorter,
		);
	const other = candidate === left ? right : left;
	const availableHeight = window.innerHeight - 128;

	// A column taller than the viewport must remain in normal flow so all of it
	// can still be reached.
	if (candidate.offsetHeight <= availableHeight && candidate.offsetHeight + 24 < other.offsetHeight) {
		candidate.classList.add("is-sticky");
	}
}

function initTwoColumnReveals() {
	const sections = document.querySelectorAll(TWO_COLUMN_REVEAL_SELECTOR);

	if (!sections.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		for (const section of sections) {
			section.classList.add(TWO_COLUMN_REVEAL_VISIBLE_CLASS);
		}

		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					continue;
				}

				entry.target.classList.add(TWO_COLUMN_REVEAL_VISIBLE_CLASS);
				observer.unobserve(entry.target);
			}
		},
		{
			threshold: 0.2,
		},
	);

	for (const section of sections) {
		section.classList.add(TWO_COLUMN_REVEAL_PENDING_CLASS);
		observer.observe(section);
	}
}

export function initTwoColumnSticky() {
	initTwoColumnReveals();

	for (const section of document.querySelectorAll(TWO_COLUMN_SELECTOR)) {
		const update = () => updateStickyColumn(section);
		const observer = new ResizeObserver(update);

		for (const column of section.querySelectorAll("[data-two-column-side]")) {
			observer.observe(column);
		}

		DESKTOP_QUERY.addEventListener("change", update);
		window.addEventListener("resize", update, { passive: true });
		update();
	}
}
